import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { QualitativeInputActions } from './qualitative-input.actions';
import { QualitativeInputService } from '../../service/qualitative-input.service';
import { QualitativeProcess } from '../../../../graphql/generated';

@Injectable()
export class QualitativeInputEffects {

  loadQualitativeInputs$ = createEffect(
    (rs: QualitativeInputService = inject(QualitativeInputService)) => {
      return this.actions$.pipe(

        ofType(QualitativeInputActions.loadQualitativeInputs),
        mergeMap((parameters) =>
          rs.getQualitative(parameters.legalEntityId, parameters.campaignId, parameters.params, parameters.completed).pipe(
            map((riskMap) => {
              return QualitativeInputActions.loadQualitativeInputsSuccess(
                { qualitative: riskMap?.data?.[0]?.processes as QualitativeProcess[], totalElements: riskMap?.totalElements }
              );
            }),
            catchError((error) => of(QualitativeInputActions.loadQualitativeInputsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadAllQualitativeInputs$ = createEffect(
    (rs: QualitativeInputService = inject(QualitativeInputService)) => {
      return this.actions$.pipe(

        ofType(QualitativeInputActions.loadAllQualitativeInputs),
        mergeMap((parameters) =>
          rs.getQualitative(parameters.legalEntityId, parameters.campaignId, parameters.params).pipe(
            map((riskMap) => {
              return QualitativeInputActions.loadAllQualitativeInputsSuccess(
                { qualitative: riskMap?.data?.[0]?.processes as QualitativeProcess[] }
              );
            }),
            catchError((error) => of(QualitativeInputActions.loadAllQualitativeInputsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateQualitativeInputs$ = createEffect(
    (rs: QualitativeInputService = inject(QualitativeInputService)) => {
      return this.actions$.pipe(

        ofType(QualitativeInputActions.updateQualitativeInput),
        mergeMap((parameters) =>
          rs.updateQualitative(parameters.questionId, parameters.id, parameters.comments, parameters.levelRelevanceId, parameters.opinionId).pipe(
            map(() => {
              return QualitativeInputActions.updateQualitativeInputSuccess(
                { status: true, cptId: parameters.cptId, questionId: parameters.questionId }
              );
            }),
            catchError((error) => of(QualitativeInputActions.updateQualitativeInputFailure({ error, cptId: parameters.cptId, questionId: parameters.questionId })))
          )
        )
      );
    },
    { functional: true }
  );

  createQualitativeInputs$ = createEffect(
    (rs: QualitativeInputService = inject(QualitativeInputService)) => {
      return this.actions$.pipe(

        ofType(QualitativeInputActions.createQualitativeInput),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.createQualitative(parameters.questionId, parameters.opinionId, parameters.legalEntityId, parameters.comments, parameters.campaignId, parameters.cptId).pipe(
            map((res) => {
              return QualitativeInputActions.createQualitativeInputSuccess(
                { status: true, cptId: parameters.cptId, questionId: parameters.questionId }
              );
            }),
            catchError((error) => of(QualitativeInputActions.createQualitativeInputFailure({ error, cptId: parameters.cptId, questionId: parameters.questionId })))
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
